<!doctype html>
<html lang="en">
  <head>
    <title>Print Graph</title>
  </head>

  <body id="pdf-data" #pdfContent>
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"auto"}'>
          <img
            alt="Org logo"
            [src]="sheetData?.logo"
            data-pdfmake='{"width": 125, "fit": [125, 40]}' />
        </div>
        <div data-pdfmake='{"width":"*", "margin": [10, 0]}'>
          <div class="desc" style="text-align: right">
            {{ sheetData?.orgDetail.address }}
          </div>
          <div class="address" style="text-align: right">
            {{ sheetData?.orgDetail.city }}, {{ sheetData?.orgDetail.state }},
            {{ sheetData?.orgDetail.country }},
            {{ sheetData?.orgDetail.zipCode }}
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ sheetData?.caseDetail.student.firstName }}
          {{ sheetData?.caseDetail.student.lastName }}
        </div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ sheetData?.caseDetail.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Gender</div>
          <div class="dataValue">
            <b> {{ sheetData?.caseDetail.student.gender }}</b>
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">Student School</div>
          <div class="dataValue">
            <b>{{ sheetData?.caseDetail.student.organizationName }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Date Of Birth</div>
          <div class="dataValue">
            <b>{{
              sheetData?.caseDetail.student.dateOfBirth ?? null
                | date: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Start Date</div>
          <div class="dataValue">
            <b>
              {{
                sheetData?.graphData?.dateRange[0] | userDate: 'MM/dd/yyyy'
              }}</b
            >
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">End Date</div>
          <div class="dataValue">
            <b>{{
              sheetData?.graphData?.dateRange[1] | userDate: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'></div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":147}' class="datalabel">
          <b> Category :</b>
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b>{{ sheetData?.behavior?.behaviorCategoryName }} </b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":147}' class="datalabel">
          <b> Behavior :</b>
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              sheetData?.behaviorNames?.length > 0
                ? sheetData?.behaviorNames.join(', ')
                : 'Nothing Entered'
            }}
          </b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":147}' class="datalabel">
          Operational Definition :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              sheetData?.behavior.operationalDefinition || 'Nothing Entered'
            }}
          </b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":147}' class="datalabel">Goals :</div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b>{{ sheetData?.behavior.goals || 'Nothing Entered' }} </b>
        </div>
      </div>
      <br />
      <ng-container
        *ngIf="
          sheetData?.graphData?.graphImages?.length > 0;
          else legacySingleGraphImage
        ">
        <div
          data-pdfmake='{"width":"*"}'
          *ngFor="let imageSrc of sheetData?.graphData?.graphImages">
          <img
            data-pdfmake='{"width":552}'
            [src]="imageSrc"
            [alt]="'Graph Chart'"
            class="chartImage" />
        </div>
      </ng-container>

      <ng-template #legacySingleGraphImage>
        <div
          data-pdfmake='{"width":"*"}'
          *ngIf="sheetData?.graphData?.graphImage">
          <img
            data-pdfmake='{"width":552}'
            [src]="sheetData?.graphData?.graphImage"
            [alt]="'Graph Chart'"
            class="chartImage" />
        </div>
      </ng-template>
      <br />

      <ng-container
        *ngIf="
          sheetData?.graphData?.graphImagesTotal?.length > 0;
          else legacySingleGraphImageTotal
        ">
        <div
          data-pdfmake='{"width":"*"}'
          *ngFor="let imageSrc of sheetData?.graphData?.graphImagesTotal">
          <img
            data-pdfmake='{"width":552}'
            [src]="imageSrc"
            [alt]="'Graph Total Chart'"
            class="chartImage" />
        </div>
      </ng-container>

      <ng-template #legacySingleGraphImageTotal>
        <div
          data-pdfmake='{"width":"*"}'
          *ngIf="sheetData?.graphData?.graphImageTotal">
          <img
            data-pdfmake='{"width":552}'
            [src]="sheetData?.graphData?.graphImageTotal"
            [alt]="'Graph Total Chart'"
            class="chartImage" />
        </div>
      </ng-template>
    </div>
  </body>
</html>
